import { render, staticRenderFns } from "./DateTimelineItem.vue?vue&type=template&id=8145a1b0&"
import script from "./DateTimelineItem.vue?vue&type=script&lang=js&"
export * from "./DateTimelineItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports